module.exports = __webpack_public_path__ + "static/img/16053C_1_2_R_20200915_LC.486b5f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16053C_1_2_R_20200915_LC.png
// module id = jUPM
// module chunks = 0